import {Injectable} from "@angular/core";
import {SystemApp} from "../../constans/SystemConfigurations";
import {ActivatedRoute, Router} from '@angular/router';
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {Color} from "../../app.models";
import {AdvFormService} from "../../pages/create-adv/services/adv-form.service";
import {PathOptions} from "../../pages/create-adv/dynamic-form-question/dynamic-form-question.component";
import {FilterbaseService} from "../../pages/shop/top-filter/filter-base/services/filterbase.service";
import {DynamicFormDialogService} from "../../admin/components/dynamic-form-dialog/dynamic-form-dialog.service";
import {QuestionBase} from "../../pages/create-adv/models/question-base";
import {StringUtils} from "../../utils/StringUtils";
import {TokenStore} from "../../services/token-store";
import {AdvertisementEnum} from "../../core/advertisement/advertisement.component";

@Injectable()

export class ApiUrl{

  constructor(private router: Router, private activeRouter: ActivatedRoute, public http:HttpClient) {}

  private apikTenant = this.getCookie('apiKey')
  private externalURL = this.getCookie('external_apiUrl')

  /**
   * POD1-8: the raw access token, from memory.
   *
   * Used by the WebSocket client, which cannot set headers in the browser and
   * must pass it as a subprotocol instead (see web-socket.service.ts).
   */
  public  getJWTTokenKey(): string{
    return TokenStore.get() || "";
  }

  /**
   * POD1-8: the Authorization header value.
   *
   * Every authenticated call in the app builds its header from this one
   * method, which is why moving the credential out of localStorage only
   * needed a change here rather than in ~20 components.
   *
   * Now emits `Bearer` (JWT) instead of `Token` (legacy DRF key). The backend
   * accepts both during the transition, so this can ship on its own.
   */
  public getJWTToken(){
    const access = TokenStore.get();
    if(!StringUtils.isEmpty(access)){
      return 'Bearer ' + access;
    }
    return "";
  }

  public getCookie(cname:string): string{
    const name = cname + "="
    const ca = document.cookie.split(';')
    for(let i = 0; i < ca.length; i++){
      let c = ca[i];
      while (c.charAt(0) == ' '){
        c = c.substring(1);
      }
      if(c.indexOf(name) == 0){
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  getSliders(): string {
    return SystemApp.base_url_api + '/api/slider/'
  }

  getColor(): string {
    return SystemApp.base_url_api + '/api/colors/'
  }
  getSize(): string {
    return SystemApp.base_url_api + '/api/sizes/'
  }



  getProducts(mainCategory:string, subCategory:string|null = null): string{
    let url = SystemApp.base_url_api + '/clientAjax/product/?mainCategory=' + mainCategory;
    if(subCategory != null){
      url += "&subCategory="+subCategory;
    }
    return url;
  }

  getPages(): string{
    return SystemApp.base_url_api + '/pages/'
  }

  getCategories(): string {
    return SystemApp.base_url_api + '/api/mainCategory/'
  }

  getBanners(): string {
    return SystemApp.base_url_api + '/api/banners/'
  }



  getProduct(productId:string): string{
    return SystemApp.base_url_api + '/clientAjax/product/' + productId + '/';
  }
  getAdminAdvs(): string{
    return SystemApp.base_url_api + '/myAdmin/advs/';
  }
  getAdminStores(): string {
    return SystemApp.base_url_api + '/myAdmin/store/';
  }
  getStoreByUserToken(): string {
    return SystemApp.base_url_api + '/store/store_info/';
  }

  getStores(): string {
    return SystemApp.base_url_api + '/api/store/';
  }

  loginUser(): string{
    return SystemApp.base_url_api + '/api-token-auth/'
  }

  getCategory(): string {
    return SystemApp.base_url_api + '/api/mainCategory/';
  }

  getBrands(): string {
    return SystemApp.base_url_api + '/api/brands/';
  }
  getOrder(): string {
    return SystemApp.base_url_api + '/api/orders/';
  }
  getUserDetails(): string {
    return SystemApp.base_url_api + '/api/users/';
  }
  getAllUsers(): string{
    return SystemApp.base_url_api + '/admin-api/users/'
  }
  getBanner(): string {
    return SystemApp.base_url_api + '/admin-api/banners/';
  }
  getSlider(): string {
    return SystemApp.base_url_api + '/api/slider/';
  }
  getVideo(): string {
    return SystemApp.base_url_api + '/api/video/';
  }

  public getUrlParam(params: string): Observable<any>{
    const a = new Observable(observer => {
      this.activeRouter.queryParams.subscribe(res =>{
        observer.next(res[params])
      });
    })
    return a;
  }


  registerUser(): string{
    return SystemApp.base_url_api + '/api/users/'
  }

  getTopcategory(): string{
    return SystemApp.base_url_api + '/ads/topcategory'
  }

  getCarouselSlider(): string{
    return SystemApp.base_url_api + '/clientAjax/carouselSlider'
  }

  getTopProducts(): string{
    return SystemApp.base_url_api + '/clientAjax/top6products'
  }

  getUserInfo(): string{
    return SystemApp.base_url_api + '/user/user_info/'
  }

  getAds(): string{
    return SystemApp.base_url_api + '/user/user_ads/'
  }

  public getNameSpacePos(delimiter:string, position:number){
    const url = this.router.url.split(/[?#]/, 1)[0]
    return url.$piece(delimiter,position)
  }

  private buildBasePath(pathUrl: string): string {
    const endpoint = pathUrl.$piece("*", 1).trim();
    if (/^https?:\/\//i.test(endpoint)) return endpoint;
    return SystemApp.base_url_api + '/' + endpoint.replace(/^\/+/, '');
  }

  private resolveParamValue(
      paramKey: string,
      formService: AdvFormService | FilterbaseService | DynamicFormDialogService,
      questionObj: QuestionBase<any> | null
  ): string {
    const question = formService.getQuestion(paramKey);
    if (!question) return '';

    if (questionObj?.parentMapValue != null) {
      return question[questionObj.parentMapValue.toString()] ?? '';
    }
    return question.value?.value ?? '';
  }

  private parseQueryParams(
      uri: string,
      formService: AdvFormService | FilterbaseService | DynamicFormDialogService,
      questionObj: QuestionBase<any> | null
  ): Array<{ index: string; value: string }> {
    // Empty pieces (a trailing '&' in the seed data, e.g. the SALE2 model
    // list) used to produce a bare '=' parameter.
    return uri.split("&").filter(param => param.trim() !== '').map(param => {
      const index = param.$piece("=", 1);
      const paramKey = param.$piece("=", 2);
      const value = this.resolveParamValue(paramKey, formService, questionObj);
      return { index, value };
    });
  }

  private buildQueryString(params: Array<{ index: string; value: string }>): string {
    // Values are answers (labels may contain '&', '#', '+'...) -> encoded.
    return params.map(p => `${p.index}=${encodeURIComponent(p.value ?? '')}`).join("&");
  }

  private appendRequiredParams(fullPath: string, requiredParam: string): string {
    if (!requiredParam) return fullPath;

    // additionalParam is a ','- or '&'-separated list of name=value pairs.
    // The pieces used to be glued together with NO '&' (and with no '&'
    // after an existing query string): '?cityCode=5table_name=regions'.
    const parts = requiredParam.split(/[,&]/)
      .map(part => part.trim().replace(/^[?&]+/, ''))
      // only name=value pairs (the admin dialog passes relatedField keys here)
      .filter(part => part !== '' && part.includes('='));
    if (!parts.length) return fullPath;
    const separator = !fullPath.includes("?") ? "?"
      : (fullPath.endsWith("?") || fullPath.endsWith("&")) ? "" : "&";
    return fullPath + separator + parts.join("&");
  }

  public pathTranslate(
      pathUrl: string,
      formService: AdvFormService | FilterbaseService | DynamicFormDialogService,
      requiredParam: string = '',
      questionObj: QuestionBase<any> = null
  ): PathOptions {
    pathUrl = pathUrl.trim();
    const originalPath = this.buildBasePath(pathUrl);
    const absolutePath = originalPath.$piece("?", 1);
    const uri = originalPath.$piece("?", 2);

    let paramsArr: Array<{ index: string; value: string }> = [];
    let fullPath = absolutePath;

    if (uri) {
      paramsArr = this.parseQueryParams(uri, formService, questionObj);
      fullPath += "?" + this.buildQueryString(paramsArr);
    }

    fullPath = this.appendRequiredParams(fullPath, requiredParam);

    return {
      path: fullPath,
      displayField: pathUrl.$piece("*", 2),
      requiredField: paramsArr,
      absoluteUrl: absolutePath
    };
  }

  public getNameSpace(): string{
    const url = this.router.url
    return url.$piece('/publish/',2)
  }

  getFormsQuestion(namespance: string, subCategoryId: string | number | null = null): string{
    const subCategory = subCategoryId !== null && subCategoryId !== undefined && subCategoryId !== ''
      ? '&subCategory=' + encodeURIComponent(String(subCategoryId))
      : '';
    return SystemApp.base_url_api + '/dynamicForm/?namespace='+namespance + subCategory
  }

  getFormsQuestionUrl(): string{
    return SystemApp.base_url_api + '/clientAjax/adv/publish/'
  }
  getMainCategory(): string{
    return SystemApp.base_url_api + '/clientAjax/mainCategory'
  }
  getSubCategory(nameSpace: string): string{
    return SystemApp.base_url_api + '/clientAjax/subCategory?namespace='+nameSpace;
  }
  getLicenceCarUrl(){
    return SystemApp.base_url_api + '/api/Archive/car/GetCarDescription'
  }
  getCarDescription(producer: string, mainModel: string, year: String): string{
    return SystemApp.base_url_api + '/api/Archive/car/GetCarDescription?codeProducer='+producer+'&mainModel='+mainModel+'&year='+year;
  }
  getBrowserSearch(query: string) {
    return SystemApp.base_url_api + '/clientAjax/browserSearch?q=' + encodeURIComponent(query.trim())
  }
  /** SCRUM-278: ranked, paginated rule-based search. */
  getSmartSearch(p: { q: string; type?: string; page?: number; pageSize?: number; category?: string | null; city?: number | null }) {
    const params = new URLSearchParams();
    params.set('q', (p.q || '').trim());
    if (p.type && p.type !== 'all') { params.set('type', p.type); }
    if (p.page && p.page > 1) { params.set('page', String(p.page)); }
    if (p.pageSize) { params.set('page_size', String(p.pageSize)); }
    if (p.category) { params.set('category', p.category); }
    if (p.city) { params.set('city', String(p.city)); }
    return SystemApp.base_url_api + '/clientAjax/search/v2?' + params.toString();
  }
  getSearchSuggest(query: string) {
    return SystemApp.base_url_api + '/clientAjax/search/suggest?q=' + encodeURIComponent(query.trim());
  }

  getAdvertisement(advertisementType: AdvertisementEnum ,num: number): string{
    return SystemApp.base_url_api + '/adv/generate/?num='+num+`&advertisementType=${advertisementType.toString()}`;
  }


  getPhoneValidationUrl(): string{
    return SystemApp.base_url_api + '/clientAjax/adv/phone/validation/'
  }

  getFilterBase(namespace: string, sub_category: string): string {
    const baseUrl = `${SystemApp.base_url_api}/dynamicFilterForms/`;

    const params = new URLSearchParams({
      namespace: namespace ?? '',
      sub_category: sub_category ?? ''
    });

    return `${baseUrl}?${params.toString()}`;
  }
  private getValue(){

  }


  translateData(object:any, value:string): string{
    const delimiterNum = value.$len("*")
    if(delimiterNum == 0 ){
      const strIndex = value.$piece("*",1)
      return object !=null ? object[strIndex]: null;
    }else{
      for(var i=1; i<=delimiterNum+1 ;i++){
        if(object == null)
          break
        object = object[value.$piece("*", i)]
      }
      return object !=null && object !='' ? object : null;
    }
  }

  getCarFilters(params: any ,arrPram: any){
    arrPram['codeProducer'] = this.translateData(params, 'codeProducer*label')
    arrPram['MainModel'] = this.translateData(params, 'mainModel*label')
    arrPram['min_year'] = this.translateData(params, 'year*from*label')
    arrPram['max_year'] = this.translateData(params, 'year*to*label')
    arrPram['min_price'] = this.translateData(params, 'price*from')
    arrPram['max_price'] = this.translateData(params, 'price*to')
    arrPram['min_NumberOfOwner'] = this.translateData(params, 'numberOnwer*from*label')
    arrPram['max_NumberOfOwner'] = this.translateData(params, 'numberOnwer*to*label')
    arrPram['gearBox'] = this.translateData(params, 'gearBox*value*value')
    arrPram['min_mileage'] = this.translateData(params, 'mileage*from*label')
    arrPram['max_mileage'] = this.translateData(params, 'mileage*to*label')
    arrPram['sconderyCategory'] = this.translateData(params, 'sconderyCategory*value*value')
    arrPram['CurrentOwner'] = this.translateData(params, 'CurrentOwner*value*value')
    // 2026-10-24: the backend reads `color` (not `Color`); the colour NAME
    // matches like the app's (the hex code also works server side).
    arrPram['color'] = this.translateData(params, 'color*label')
    arrPram['min_engineCapacity'] = this.translateData(params,'engineCapacity*from*label')
    arrPram['max_engineCapacity'] = this.translateData(params,'engineCapacity*to*label')
    return arrPram;
  }

  getNadlanFilters(params: any ,arrPram: any){
    arrPram['entrance'] = this.translateData(params, 'entrance')
    arrPram['sconderyCategory'] = this.translateData(params, 'sconderyCategory*value*value')
    arrPram['nadlanType'] = this.translateData(params, 'nadlanType*label')
    arrPram['availabilityEntrance'] = this.translateData(params, 'availabilityEntrance')
    arrPram['armatureList'] = this.translateData(params, 'armatureList')
    arrPram['min_Floor'] = this.translateData(params, 'Floor*from*label')
    arrPram['max_Floor'] = this.translateData(params, 'Floor*to*label')
    arrPram['min_numberOfRooms'] = this.translateData(params, 'numberOfRooms*from*label')
    arrPram['max_numberOfRooms'] = this.translateData(params, 'numberOfRooms*to*label')
    arrPram['min_buildingMeter'] = this.translateData(params, 'buildingMeter*from')
    arrPram['max_buildingMeter'] = this.translateData(params, 'buildingMeter*to')
    arrPram['min_price'] = this.translateData(params, 'price*from')
    arrPram['City'] = this.translateData(params, 'City*value*value')
    arrPram['max_price'] = this.translateData(params, 'price*to')
    return arrPram;
  }


  getSale2Filters(params: any ,arrPram: any){
    arrPram['Sale2ThirdCategory_degem'] = this.translateData(params, 'Sale2ThirdCategory_degem*label')
    arrPram['sale2ThirdCategory_thirdCategory'] = this.translateData(params, 'sale2ThirdCategory_thirdCategory*label')
    arrPram['subCategory'] = this.translateData(params, 'subCategory*value*value')
    arrPram['sconderyCategory'] = this.translateData(params, 'sconderyCategory*value*value')
    return arrPram;
  }

  getRequiredFilters(params: any ,arrPram: any){
    arrPram['jobCategory'] = this.translateData(params, 'jobCategory*label')
    // 2026-10-24: the rest of the seeded REQUIRED filter (was dropped here).
    // Multi answers go as the selected rows; Text answers as their object -
    // the backend unwraps both.
    arrPram['region'] = this.translateData(params, 'region*label')
    arrPram['experienceLevel'] = this.translateData(params, 'experienceLevel')
    arrPram['skills'] = this.translateData(params, 'skills')
    arrPram['languages'] = this.translateData(params, 'languages')
    arrPram['salary_min'] = this.translateData(params, 'salary_min')
    arrPram['salary_max'] = this.translateData(params, 'salary_max')
    arrPram['isNegotiable'] = this.translateData(params, 'isNegotiable')
    arrPram['search'] = this.translateData(params, 'search*label')
    arrPram['jobType'] = this.translateData(params, 'jobType*label')
    arrPram['workLocationType'] = this.translateData(params, 'workLocationType*label')
    arrPram['city'] = this.translateData(params, 'city*label')
    arrPram['educationLevel'] = this.translateData(params, 'educationLevel*label')
    arrPram['salaryType'] = this.translateData(params, 'salaryType*label')
    return arrPram;
  }
  getTeacherFilters(params: any ,arrPram: any){
    // (A first teachingSubjects '*label' line was always overwritten by the
    // raw rows below - which is what the backend needs - so it is gone.)
    arrPram['languages'] = this.translateData(params, 'languages')
    arrPram['lessonDuration'] = this.translateData(params, 'lessonDuration')
    arrPram['experienceYears'] = this.translateData(params, 'experienceYears')
    arrPram['teacherEducation'] = this.translateData(params, 'teacherEducation')
    arrPram['city'] = this.translateData(params, 'city*label')
    arrPram['region'] = this.translateData(params, 'region*label')
    arrPram['lessonType'] = this.translateData(params, 'lessonType')
    arrPram['studentLevel'] = this.translateData(params, 'studentLevel')
    arrPram['teachingSubjects'] = this.translateData(params, 'teachingSubjects')
    arrPram['search'] = this.translateData(params, 'search*label')

    arrPram['priceNegotiable'] = this.translateData(params, 'priceNegotiable')
    arrPram['freeTrialLesson'] = this.translateData(params, 'freeTrialLesson')
    arrPram['groupLesson'] = this.translateData(params, 'groupLesson')
    arrPram['price_max'] = this.translateData(params, 'price_max')
    arrPram['price_min'] = this.translateData(params, 'price_min')

    return arrPram;
  }

  getCoworkerFilters(params: any ,arrPram: any){
    arrPram['professionCategory'] = this.translateData(params, 'professionCategory*label')
    arrPram['serviceType'] = this.translateData(params, 'serviceType*label')
    arrPram['serviceArea'] = this.translateData(params, 'serviceArea*label')
    arrPram['city'] = this.translateData(params, 'city*label')
    arrPram['availability'] = this.translateData(params, 'availability*label')
    arrPram['experienceYears'] = this.translateData(params, 'experienceYears*label')
    // 2026-10-24: the rest of the seeded COWORKER filter (was dropped here).
    arrPram['skills'] = this.translateData(params, 'skills')
    arrPram['languages'] = this.translateData(params, 'languages')
    arrPram['pricingType'] = this.translateData(params, 'pricingType*label')
    arrPram['price_min'] = this.translateData(params, 'price_min')
    arrPram['price_max'] = this.translateData(params, 'price_max')
    arrPram['freeEstimate'] = this.translateData(params, 'freeEstimate')
    arrPram['search'] = this.translateData(params, 'search*label')
    return arrPram;
  }

  getPetFilters(params: any, arrPram: any) {
    // Basic filters
    arrPram['listingType'] = this.translateData(params, 'listingType*label')
    arrPram['petType'] = this.translateData(params, 'petType*label')
    arrPram['breed'] = this.translateData(params, 'breed*label')
    arrPram['gender'] = this.translateData(params, 'gender*label')
    arrPram['region'] = this.translateData(params, 'region*label')
    arrPram['city'] = this.translateData(params, 'city*label')

    // Advanced filters
    arrPram['age'] = this.translateData(params, 'age*label')
    arrPram['size'] = this.translateData(params, 'size*label')
    arrPram['sellerType'] = this.translateData(params, 'sellerType*label')

    // 2026-10-24: price, the checkboxes and the free text were dropped here.
    arrPram['price_min'] = this.translateData(params, 'price_min')
    arrPram['price_max'] = this.translateData(params, 'price_max')
    for (const key of ['vaccinated', 'neutered', 'trained', 'kidFriendly',
                       'suitableForYard', 'suitableForApartment', 'freeAdoption']) {
      arrPram[key] = this.translateData(params, key)
    }
    arrPram['search'] = this.translateData(params, 'search*label')

    return arrPram;
  }
  // getFilterBaseUrl(params:any): string{
  //   var arrPram:any = {}
  //
  //   if(params['mainCategory'].toLowerCase() == 'Car'.toLowerCase()){
  //     arrPram = this.getCarFilters(params, arrPram);
  //   }
  //
  //   if(params['mainCategory'].toLowerCase() == 'Nadlan'.toLowerCase()){
  //     arrPram = this.getNadlanFilters(params, arrPram);
  //   }
  //
  //   if(params['mainCategory'].toLowerCase() == 'Sale2'.toLowerCase()){
  //     arrPram = this.getSale2Filters(params, arrPram);
  //   }
  //
  //
  //   const paramArr = Object.keys(arrPram)
  //   let url = "";
  //   paramArr.forEach((key)=>{
  //     url=url+key+"="+arrPram[key]+"&"
  //   })
  //   return SystemApp.base_url_api + '/clientAjax/shop/search/'+params['mainCategory']+'?'+url
  // }

  getFilterBasePostUrl(mainCategory, limit, offset, bbox: string | null = null){
    const area = bbox ? `&bbox=${encodeURIComponent(bbox)}` : '';
    return SystemApp.base_url_api + `/clientAjax/productVFilteriewSet?limit=${limit}&offset=${offset}&model_class=${mainCategory}${area}`
  }

  /** SCRUM-253: every real-estate ad matching the filters, as map points. */
  getNadlanMapPointsUrl(mainCategory: string){
    return SystemApp.base_url_api + `/clientAjax/nadlanMapPoints?model_class=${mainCategory}`
  }
  getAccessories(mainCategoryId: string): string{
    return SystemApp.base_url_api + '/tables/GetArmatureList/?MainCategory=' + mainCategoryId;
  }


  buildPayload(mainCategory, subCategory, arrJson){
    var arrPram:any = {}

    if(arrJson['mainCategory'].toLowerCase() == 'Car'.toLowerCase()){
      arrPram = this.getCarFilters(arrJson, arrPram);
    }

    if(arrJson['mainCategory'].toLowerCase() == 'Nadlan'.toLowerCase()){
      arrPram = this.getNadlanFilters(arrJson, arrPram);
    }

    if (["sale2", "cellular", "furniture", "fashion", "boybaby"].includes((arrJson['mainCategory'] || '').toLowerCase())) {
      arrPram = this.getSale2Filters(arrJson, arrPram);
    }


    if(arrJson['mainCategory'].toLowerCase() == 'Required'.toLowerCase()){
      arrPram = this.getRequiredFilters(arrJson, arrPram)
    }
    if(arrJson['mainCategory'].toLowerCase() == 'Teacher'.toLowerCase()){
      arrPram = this.getTeacherFilters(arrJson, arrPram)
    }

    if(arrJson['mainCategory'].toLowerCase() == 'Coworker'.toLowerCase()){
      arrPram = this.getCoworkerFilters(arrJson, arrPram)
    }

    if(arrJson['mainCategory'].toLowerCase() == 'Pet'.toLowerCase()){
      arrPram = this.getPetFilters(arrJson, arrPram)
    }

    // SCRUM-263 — "private only / businesses only", in every category. The
    // per-category builders above only copy the fields they know, so this
    // one is added here for all of them. Sends the option key
    // ('private' | 'business'); clearing the field (= all advertisers)
    // sends nothing.
    const advertiser = this.advertiserValue(arrJson['advertiser']);
    if (advertiser) {
      arrPram['advertiser'] = advertiser;
    }
    return arrPram
  }

  private advertiserValue(selected: any): string | null {
    if (selected === null || selected === undefined || selected === '') return null;
    if (typeof selected === 'string') return selected;
    const inner = selected?.value;
    const raw = (inner && typeof inner === 'object') ? inner.value : inner;
    return raw ? String(raw) : (selected?.label ? String(selected.label) : null);
  }

  getAdsUrl() {
    return SystemApp.base_url_api + "/clientAjax/productAds/"
  }

  getFixedUrl(url: string):string{
    const normalized = url.trim();
    if (/^https?:\/\//i.test(normalized)) {
      return normalized.endsWith('/') ? normalized : normalized + '/';
    }
    return SystemApp.base_url_api + '/' + normalized.replace(/^\/+|\/+$/g, '') + '/';
  }
  getArmatureUrl(){
    return SystemApp.base_url_api + '/admin-api/armatures/'
  }

  // SCRUM-88 — public seller profile and store
  getSellerProfileUrl(userId: number): string {
    return SystemApp.base_url_api + '/client-api/seller/' + userId + '/'
  }

  getSellerAdsUrl(userId: number): string {
    return SystemApp.base_url_api + '/client-api/seller/' + userId + '/ads/'
  }

  getStoreUrl(): string {
    return SystemApp.base_url_api + '/client-api/users/me/store/'
  }

  // SCRUM-259 — business accounts: labels / domains config + my VIP state
  getBusinessConfigUrl(): string {
    return SystemApp.base_url_api + '/client-api/business/config/'
  }

  getBusinessStatusUrl(): string {
    return SystemApp.base_url_api + '/client-api/business/status/'
  }

  // SCRUM-266 — listing promotion
  getPromotionOptionsUrl(adId: number): string {
    return SystemApp.base_url_api + '/client-api/business/promotions/options/' + adId + '/'
  }

  getPromotionInitiateUrl(): string {
    return SystemApp.base_url_api + '/client-api/business/promotions/initiate/'
  }

  getPromotionConfirmUrl(): string {
    return SystemApp.base_url_api + '/client-api/business/promotions/confirm/'
  }

  // SCRUM-267 — performance events + report
  getBusinessEventsUrl(): string {
    return SystemApp.base_url_api + '/client-api/business/events/'
  }

  getBusinessStatsUrl(): string {
    return SystemApp.base_url_api + '/client-api/business/stats/'
  }

  // SCRUM-86 — the caller's publishing quota
  getQuotaUrl(): string {
    return SystemApp.base_url_api + '/client-api/subscriptions/quota/'
  }

  // SCRUM-311/312/313 — coupon ad entitlement (backend app `coupons/`)
  getCouponRedeemUrl(): string {
    return SystemApp.base_url_api + '/client-api/coupons/redeem/'
  }

  getMyCouponsUrl(): string {
    return SystemApp.base_url_api + '/client-api/coupons/my/'
  }

  getEligibleCouponsUrl(): string {
    return SystemApp.base_url_api + '/client-api/coupons/eligible/'
  }

  // AI flyer landing pages (backend app `flyers/`) - /promo/:slug
  getFlyerUrl(slug: string): string {
    return SystemApp.base_url_api + '/client-api/flyers/' + encodeURIComponent(slug) + '/'
  }

  getFlyerMyCodeUrl(slug: string): string {
    return SystemApp.base_url_api + '/client-api/flyers/' + encodeURIComponent(slug) + '/my-code/'
  }

  getFlyerClaimUrl(slug: string): string {
    return SystemApp.base_url_api + '/client-api/flyers/' + encodeURIComponent(slug) + '/claim/'
  }

  getFlyerPreviewUrl(token: string): string {
    return SystemApp.base_url_api + '/client-api/flyers/preview/' + encodeURIComponent(token) + '/'
  }

  // SCRUM-87 — follow
  getFollowUrl(userId: number): string {
    return SystemApp.base_url_api + '/client-api/users/' + userId + '/follow/'
  }

  // SCRUM-101 — block / unblock
  getBlockUrl(userId: number): string {
    return SystemApp.base_url_api + '/client-api/users/' + userId + '/block/'
  }

  getMyFollowersUrl(): string {
    return SystemApp.base_url_api + '/client-api/users/me/followers/'
  }

  getBlockedListUrl(): string {
    return SystemApp.base_url_api + '/client-api/users/me/blocked/'
  }

  getFollowFeedUrl(): string {
    return SystemApp.base_url_api + '/client-api/users/me/feed/'
  }

  getAdsRouteUrl() {
    return SystemApp.base_url_api + '/admin-api/ads-route/'
  }

  getOrdersUrl() {
    return SystemApp.base_url_api + '/admin-api/orders/'
  }

  getClientAdsRouteUrl() {
    return SystemApp.base_url_api + '/client-api/ads-routes/'
  }

  checkoutAdv(): string {
    return SystemApp.base_url_api + '/client-api/check-out/';
  }

  getSubscriptionPlans(): string {
    return SystemApp.base_url_api + '/client-api/subscriptions/plans/';
  }

  initiateSubscription(): string {
    return SystemApp.base_url_api + '/client-api/subscriptions/initiate/';
  }

  confirmSubscription(): string {
    return SystemApp.base_url_api + '/client-api/subscriptions/confirm/';
  }

  mySubscriptions(): string {
    return SystemApp.base_url_api + '/client-api/subscriptions/my/';
  }

  initiateMarketPurchase(): string {
    return SystemApp.base_url_api + '/client-api/market/initiate/';
  }

  confirmMarketPurchase(): string {
    return SystemApp.base_url_api + '/client-api/market/confirm/';
  }

  initiateCartCheckout(): string {
    return SystemApp.base_url_api + '/client-api/market/cart-initiate/';
  }

  confirmCartCheckout(): string {
    return SystemApp.base_url_api + '/client-api/market/cart-confirm/';
  }
  getLableLanguage() {
    return SystemApp.base_url_api + '/admin-api/label-translate/'
  }
  getDGMCar() {
    return SystemApp.base_url_api + '/admin-api/label-translate/'
  }
  getTriggerAsyncTask(){
    return SystemApp.base_url_api + '/async-task/taskmetadata/latest/'
  }

  getNotificationsUrl(): string{
    return SystemApp.base_url_api + `/notification-api/notifications/`
  }
  getUnreadCountNotificationsUrl(): string{
    return SystemApp.base_url_api + `/notification-api/notifications/app_info`
  }
  markAsReadUrl(): string{
    return SystemApp.base_url_api + `/notification-api/notifications/mark_read/`
  }
  raiseFlagUrl(): string{
    return SystemApp.base_url_api + `/notification-api/notifications/raise_flag/`
  }
  getChatRoomsUrl(): string{
    return SystemApp.base_url_api + `/api/chat/chatrooms`
  }

  getOnlineUsersUrl(): string{
    return SystemApp.base_url_api + `/admin-api/online-users/`
  }
  getCreateSessionUrl(): string{
    return SystemApp.base_url_api + `/api/stories/upload-session/`
  }
  getCommitUrl(): string{
    return SystemApp.base_url_api + `/api/stories/commit/`
  }
  getCancelUrl(): string{
    return SystemApp.base_url_api + `/api/stories/cancel/`
  }
  getPresignUrl(): string{
    return SystemApp.base_url_api + `/api/stories/presign-get/`
  }

  // ── Finance Admin Panel (SCRUM-53/56/57/58) ──────────────────────────────
  // reports.urls is mounted at admin-api/finance/ (see sale4you/urls.py),
  // payments.urls at api/payments/, ecommerce.urls at api/orders/ — NOT the
  // /api/admin/finance/... paths shown in the ticket specs.

  getFinancePaymentsUrl(): string {
    return SystemApp.base_url_api + '/admin-api/finance/payments/'
  }

  getFinanceTransactionsUrl(): string {
    return SystemApp.base_url_api + '/admin-api/finance/transactions/'
  }

  getFinanceTransactionDetailUrl(category: string, id: string | number): string {
    return SystemApp.base_url_api + `/admin-api/finance/transactions/${category}/${id}/`
  }

  // SCRUM-53/58 (FK-bridge session): refund/cancel — only usable when the
  // detail row has a payment_transaction_id (see RefundTransactionView).
  getFinanceTransactionRefundUrl(category: string, id: string | number): string {
    return SystemApp.base_url_api + `/admin-api/finance/transactions/${category}/${id}/refund/`
  }

  getFinanceTransactionCancelUrl(category: string, id: string | number): string {
    return SystemApp.base_url_api + `/admin-api/finance/transactions/${category}/${id}/cancel/`
  }

  getFinanceReconcileUrl(): string {
    return SystemApp.base_url_api + '/admin-api/finance/reconcile/'
  }

  getFinanceManualPaymentUrl(): string {
    return SystemApp.base_url_api + '/admin-api/finance/manual-payments/'
  }

  getFinancePendingVerificationsUrl(): string {
    return SystemApp.base_url_api + '/admin-api/finance/manual-payments/pending/'
  }

  getFinanceVerifyManualPaymentUrl(category: string, id: string | number): string {
    return SystemApp.base_url_api + `/admin-api/finance/manual-payments/${category}/${id}/verify/`
  }

  getFinanceReportUrl(reportName: string): string {
    return SystemApp.base_url_api + `/admin-api/finance/reports/${reportName}/`
  }

  getFinanceDailyRevenueEmailUrl(): string {
    return SystemApp.base_url_api + '/admin-api/finance/reports/daily-revenue/email/'
  }

  getFinanceCategoryRevenueUrl(): string {
    return SystemApp.base_url_api + '/admin-api/finance/reports/categories/'
  }

  getFinanceCategoryRevenueTrendUrl(): string {
    return SystemApp.base_url_api + '/admin-api/finance/reports/categories/trend/'
  }

  getPaymentTransitionsUrl(id: number | string): string {
    return SystemApp.base_url_api + `/api/payments/${id}/transitions/`
  }

  getPaymentTransitionUrl(id: number | string): string {
    return SystemApp.base_url_api + `/api/payments/${id}/transition/`
  }

  getBankTransferVerifyUrl(id: number | string): string {
    return SystemApp.base_url_api + `/api/payments/bank-transfers/${id}/verify/`
  }

  getCheckActionUrl(id: number | string, action: string): string {
    return SystemApp.base_url_api + `/api/payments/checks/${id}/${action}/`
  }

  getOrderPaymentLinkUrl(orderId: number | string): string {
    return SystemApp.base_url_api + `/api/orders/${orderId}/payment-link/`
  }

}
